import * as React from 'react';
import AudioReactRecorder, { RecordState } from 'audio-react-recorder'
import { useState } from 'react';
import { AudioPlayer } from '../../../../Components/AudioPlayer/AudioPlayer';

import './VoiceRecorder.scss';
export interface IVoiceRecorderProps {
    hanldeVoiceSubmit: any,
}

export function VoiceRecorder({ hanldeVoiceSubmit }: IVoiceRecorderProps) {
    const [recordState, setRecordState] = useState('')
    const [recordData, setRecordData] = useState<any>(null)

    const stop = () => {
        setRecordState(RecordState.STOP)
    }
    const start = () => {
        setRecordState(RecordState.START)
    }

    const hanldeOnStop = (e: any) => {
        setRecordData(e);
    }

    const handleRerecord = () => {
        setRecordState('')
        setRecordData(null)
    }



    const setVideoPlayer = (src: any) => {
        const plyrProps: any = {
            source: {
                type: 'audio',
                title: 'Example title',
                sources: [
                    {
                        src: src,
                        type: 'audio/mp3',
                        size: 720,
                        provider: 'html5',

                    },
                ],
            },
            options: {
                enabled: true,
                debug: false,
                loadSprite: true,
                tooltips: { controls: false, seek: true },

            },
        }

        return (
            plyrProps
        )
    }



    return (
        <div className="mt-2">

            {recordData
                ? <AudioPlayer audioPlyrProps={setVideoPlayer(recordData?.url)} />
                : <div className="bg-[#363375] rounded-lg">
                    <AudioReactRecorder state={recordState} onStop={hanldeOnStop} backgroundColor="#363375" foregroundColor="#fff" />
                </div>
            }




            {/* Buttons */}
            <div className="mt-5 flex justify-center items-center">
                {recordData
                    ? <div>
                        <button onClick={handleRerecord} className="gradientBtn text-white px-4 py-2 sm:px-5 sm:py-3 rounded-md ml-3 text-xs sm:text-base">Rerecord</button>
                        <button onClick={() => hanldeVoiceSubmit(recordData)} className="gradientBtn text-white px-4 py-2 sm:px-5 sm:py-3 rounded-md ml-3 text-xs sm:text-base">Send</button>
                    </div>
                    : <>
                        {recordState === ''
                            ? <button onClick={start} className="gradientBtn text-white px-2 py-2 sm:px-3 sm:py-3 rounded-md flex justify-center items-center
                            text-xs sm:text-base">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 sm:h-5 sm:w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
                                </svg>
                                <p className="ml-1">Start Recording</p>
                            </button>
                            : recordState === 'stop' &&
                            <button onClick={start} className="gradientBtn text-white px-2 py-2 sm:px-3 sm:py-3 rounded-md flex justify-center items-center
                            text-xs sm:text-base">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 sm:h-5 sm:w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
                                </svg>
                                <p className="ml-1">Start Recording</p>
                            </button>
                        }

                        {recordState === 'start' &&
                            <button onClick={stop} className="gradientBtn text-white px-5 py-3 rounded-md ml-3">Stop</button>}
                    </>

                }
            </div>
        </div>
    );
}